import React from 'react';
import type { Message } from '@/types/chat';
import StandardMessage from './StandardMessage';
import ProposalContextMessage from './ProposalContextMessage';

interface MessageRendererProps {
  message: Message;
  userId?: string;
}

const MessageRenderer: React.FC<MessageRendererProps> = ({
  message,
  userId
}) => {
  const isFromUser = message.sender_id === userId;
  const messageType = message.metadata?.type;

  // Route to appropriate message component based on metadata type
  switch (messageType) {
    case 'proposal_context':
      return (
        <ProposalContextMessage 
          message={message} 
          isFromUser={isFromUser} 
        />
      );
    
    // Future message types can be added here:
    // case 'quote_update':
    //   return <QuoteUpdateMessage message={message} isFromUser={isFromUser} />;
    // case 'appointment_request':
    //   return <AppointmentRequestMessage message={message} isFromUser={isFromUser} />;
    
    default:
      // Fallback to standard message for plain text, images, or unknown types
      return (
        <StandardMessage 
          message={message} 
          isFromUser={isFromUser} 
        />
      );
  }
};

export default MessageRenderer;